"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNewBarData = exports.handleIncomingBarData = void 0;
const time_1 = require("./time");
const handleIncomingBarData = (props) => {
    const { selectedPeriod, loading, activeSymbol, barData, useNewDataAsOpen, newDataItem, isMs, onUpdateCurrentBar, onGenerateNewBar, } = props;
    if (!loading && activeSymbol && barData.length > 0) {
        const newBarData = [...barData];
        const latest = newBarData[newBarData.length - 1];
        const { ask: newAsk, open: newOpen, close: newClose } = newDataItem;
        const { open: lastOpen, low: lastLow, high: lastHigh } = latest;
        const latestTime = latest.time;
        const seconds = (0, time_1.periodToSeconds)(selectedPeriod) * (isMs ? 1000 : 1);
        // Max time for current candle
        const maxCurrentCandleTime = latestTime + seconds;
        const isNextCandle = newDataItem.time >= maxCurrentCandleTime;
        if (isNextCandle) {
            return (0, exports.generateNewBarData)({
                newDataItem,
                selectedPeriod,
                barData,
                onGenerateNewBar,
                isMs,
            });
        }
        const finalData = {
            time: latest.time,
            ask: newAsk,
            open: useNewDataAsOpen ? newOpen : lastOpen,
            close: newClose,
            low: newClose < lastLow ? newClose : lastLow,
            high: newClose > lastHigh ? newClose : lastHigh,
        };
        if (newBarData.length === 0) {
            finalData.low = newClose;
            finalData.high = newClose;
            newBarData.push(finalData);
        }
        else {
            newBarData.splice(newBarData.length - 1, 1, finalData);
        }
        onUpdateCurrentBar([...newBarData]);
        return finalData;
    }
    return null;
};
exports.handleIncomingBarData = handleIncomingBarData;
const generateNewBarData = ({ newDataItem, selectedPeriod, barData, onGenerateNewBar, isMs, }) => {
    const newBarData = [...barData];
    // Use new bid from the socket message as close of the new candlestick
    const { ask, close } = newDataItem;
    const latest = newBarData[newBarData.length - 1];
    const latestTime = latest.time;
    const seconds = (0, time_1.periodToSeconds)(selectedPeriod) * (isMs ? 1000 : 1);
    const newTime = Math.floor(Math.floor(newDataItem.time) / seconds) * seconds;
    const maxCurrentCandleTime = latestTime + seconds;
    let nextCandleTime = maxCurrentCandleTime;
    if (newTime >= maxCurrentCandleTime) {
        nextCandleTime = newTime;
    }
    const transformedNewBarData = {
        open: close,
        close: close,
        low: close,
        high: close,
        ask: ask,
        time: nextCandleTime,
    };
    newBarData.push(transformedNewBarData);
    onGenerateNewBar(newBarData);
    return transformedNewBarData;
};
exports.generateNewBarData = generateNewBarData;
